import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "14",
  fill: "none",
  viewBox: "0 0 15 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.22.351c.457-.468 1.262-.468 1.723 0l5.863 5.944c.352.357.457.885.265 1.348-.187.463-.63.764-1.124.764h-.74v3.91c0 .672-.54 1.22-1.203 1.22H8.477a.615.615 0 0 1-.607-.617V9.2H6.298v3.72a.615.615 0 0 1-.608.616H3.164a1.21 1.21 0 0 1-1.202-1.218v-3.91h-.745c-.494 0-.937-.302-1.124-.765a1.25 1.25 0 0 1 .265-1.348zm-5 6.82h1.353c.333 0 .608.278.608.616v4.526l1.906-.009V8.968a.997.997 0 0 1 .99-1.005h2.02c.55 0 .992.45.992 1.005v3.331h1.92l-.013-4.512c0-.338.274-.616.607-.616l1.349-.005-5.863-5.944.003-.005z"
    }, null, -1)
  ]))]))
}
export default { render: render }